import { Component, ErrorInfo, Fragment, PropsWithChildren } from 'react';

import Logger, { LoggerOrigin } from '@/services/Logger';
import TelemetryService from '@/services/telemetry/TelemetryService';

export class ErrorBoundary extends Component<PropsWithChildren> {
  public static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    TelemetryService.trackException(error, 'ErrorBoundaries', { errorInfo });

    Logger.error(
      LoggerOrigin.ErrorBoundaries,
      '(╯°□°）╯︵ ┻━┻',
      error,
      errorInfo,
    );
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}
